import { LogLevel } from "@azure/msal-browser";
//import config from "../../config";

//console.log("window.RUNTIME_CONFIG (authConfig.js): ", window.RUNTIME_CONFIG);

function getStorageValue(key, item) {
  const saved = localStorage.getItem(key);
  const configObject = JSON.parse(saved);
  const value = configObject ? configObject[item] : null;
  return value;
}

function resolveAuthValue(key) {
  if (window.RUNTIME_CONFIG && window.RUNTIME_CONFIG[key] !== undefined && window.RUNTIME_CONFIG[key] !== null) {
    return window.RUNTIME_CONFIG[key];
  }

  const storageAliases = {
    REACT_APP_CLIENT_ID: "clientId",
    REACT_APP_AUTHORITY: "authority",
    REACT_APP_REDIRECT_URI: "redirectUri",
    REACT_APP_INSTANCE: "instance",
  };

  return getStorageValue("authConfig", key) ?? getStorageValue("authConfig", storageAliases[key]);
}

function isPlaceholder(value) {
  return typeof value === "string" && /^#\{.+\}#$/.test(value.trim());
}

function validateAuthConfig(authConfig) {
  const missing = [];

  if (!authConfig.clientId || isPlaceholder(authConfig.clientId)) {
    missing.push("REACT_APP_CLIENT_ID");
  }
  if (!authConfig.authority || isPlaceholder(authConfig.authority)) {
    missing.push("REACT_APP_AUTHORITY");
  }
  if (!authConfig.redirectUri || isPlaceholder(authConfig.redirectUri)) {
    missing.push("REACT_APP_REDIRECT_URI");
  }

  if (missing.length > 0) {
    console.error(
      `[Auth config] Missing or unresolved values: ${missing.join(", ")}. Check public/config.js replacement and localStorage authConfig.`
    );
  } else {
    console.info("[Auth config] All required MSAL values are present.");
  }
}

const resolvedAuthConfig = {
  clientId: resolveAuthValue("REACT_APP_CLIENT_ID"),
  authority: resolveAuthValue("REACT_APP_AUTHORITY"),
  redirectUri: resolveAuthValue("REACT_APP_REDIRECT_URI"),
};

validateAuthConfig(resolvedAuthConfig);

export const msalConfig = {
    auth: {
      clientId: resolvedAuthConfig.clientId,
      authority: resolvedAuthConfig.authority,
      redirectUri: resolvedAuthConfig.redirectUri,


    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
      loggerOptions: {	
          loggerCallback: (level, message, containsPii) => {	
              if (containsPii) {		
                  return;		
              }		
              switch (level) {
                  case LogLevel.Error:
                    //   console.error(message);
                      return;
                  case LogLevel.Info:
                    //   console.info(message);
                      return;
                  case LogLevel.Verbose:
                    //   console.debug(message);
                      return;
                  case LogLevel.Warning:
                    //   console.warn(message);
                      return;
                  default:
                      return;
              }	
          }	
      }	
  }
  };


    // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
    const defaultScope = resolvedAuthConfig.clientId
      ? `api://${resolvedAuthConfig.clientId}/User.Read`
      : null;

    if (!defaultScope) {
      console.error("[Auth config] Cannot build API scope because REACT_APP_CLIENT_ID is missing.");
    }

    export const loginRequest = {
      scopes: defaultScope ? [defaultScope] : []
    };
  
  // Add the endpoints here for Microsoft Graph API services you'd like to use.
  export const graphConfig = {
      graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
  };